import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import { NodeType } from '@ispm/shared/bpmn-io/node-type';
import { PathwaysModeling } from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import { taskType } from '@ispm-shared/modules/bpmn';
import { ifNodeOfType } from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/command-interceptor-utils';
import { CommandType } from '@ispm/shared/bpmn-io/bpmn-js';

export class NeighborhoodHeadNodeBehavior extends CommandInterceptor {


    constructor(eventBus: EventBus, private pathwaysModeling: PathwaysModeling) {
        super(eventBus);
        super.postExecuted([CommandType.APPEND_NODE], ifNodeOfType((this.createNeighborhoodHeadNode.bind(this)), NodeType.neighborhood_entry));
    }

    createNeighborhoodHeadNode(event) {
        const context = event.context;
        const neighborhoodEntryNode = context.node;
        if (neighborhoodEntryNode.outgoing.length == 0) {
            const neighborhoodHeadNode = this.pathwaysModeling.appendNewNode(neighborhoodEntryNode, taskType, NodeType.neighborhood_head);
            this.pathwaysModeling.setElementVisibility(neighborhoodHeadNode, true);
            this.pathwaysModeling.setElementVisibility(neighborhoodHeadNode.incoming[0], true);
        }
    }

}

NeighborhoodHeadNodeBehavior.$inject = [...CommandInterceptor.$inject, 'pathwaysModeling', 'modeling'];
